import MediaArticlePage from './MediaArticlePage';
import applyBasicPageHandlers from '../utils/applyBasicPageHandlers';

export default applyBasicPageHandlers(MediaArticlePage);
